<button type="button" class="secondary-button bulk-button" routerLink="/dashboard/academic-management/student-import">
  <svg fill="#fff" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="m764.386 112.941 225.882 338.824H1920v1185.882c0 88.213-67.799 160.913-154.016 168.718l-15.396.694H169.412c-88.214 0-160.913-67.799-168.718-154.016L0 1637.647V112.941h764.386Zm-60.537 112.941H112.941v1411.765c0 27.708 20.079 50.776 46.354 55.56l10.117.91h1581.176c27.608 0 50.754-19.989 55.557-46.324l.914-10.146V564.706H225.882V451.765H854.4L703.85 225.882Zm312.622 564.706v282.353h282.353v112.941H1016.47v282.353H903.529v-282.353H621.176v-112.94H903.53V790.587h112.942Z" fill-rule="evenodd"></path> </g></svg>
  <p>Bulk Student Upload</p>
</button>

<section class="table-content">

  <div class="filters">
    <input (input)="getStudents('search', search)" [(ngModel)]="search" type="search" name="search" id="search"
           placeholder="Search name, admission number, parent name...">

    <div>
      @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
        <select (change)="getStudents('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                id="schoolId">
          <option value="" hidden disabled>Select a school</option>
          <option value="">All School</option>


          @for (s of schools()?.payload; track $index) {
            <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
          }

        </select>
      }

      <select (change)="getStudents('sex', sex)" [(ngModel)]="sex" name="sex" id="sex">
        <option value="" hidden disabled>Select gender</option>
        <option value="">All Sex</option>

        <option value="MALE">Male</option>
        <option value="FEMALE">Female</option>
      </select>

      <select (change)="getStudents('status', status)" [(ngModel)]="status" name="status" id="status">
        <option value="" hidden disabled>Select a status</option>
        <option value="">All Statuses</option>

        <option value="ACTIVE">Active</option>
        <option value="GRADUATED">Graduated</option>
        <option value="TRANSFERRED">Transferred</option>
        <option value="SUSPENDED">Suspended</option>
        <option value="WITHDRAWN">Withdrawn</option>
      </select>

    </div>
  </div>

  <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th>STUDENT ID</th>
        <th>FULL NAME</th>
        <th>GENDER</th>
        <th>DATE OF BIRTH</th>
        <th>DATE ENROLLED</th>
        <th>STATUS</th>
        <th class="options-column">ACTIONS</th>
      </tr>
      </thead>

      <tbody>
        @if (isFiltering()) {
          <td colspan="7">
            <app-loading-indicator />
          </td>
        } @else {
          @if (!students()?.payload?.length) {
            <tr>
              <td colspan="7" class="empty">
                <app-not-found-error>
                  NO STUDENTS FOUND
                </app-not-found-error>
              </td>
            </tr>
          } @else {
            @for (u of students()?.payload; track u.id) {
              <tr>
                <td>
                  {{ u.public_id }}
                </td>

                <td>
                  {{ Helpers.capitalizeWords(Helpers.fullName({first_name: u.last_name, last_name: u.first_name})) }}
                </td>

                <td class="role">
                  <p [ngClass]="u.sex">
                    {{ u.sex }}
                  </p>
                </td>

                <td>
                  {{ Helpers.formatDate(u.date_of_birth) }}
                </td>

                <td>
                  {{ Helpers.formatDate(u.admission_date) }}
                </td>

                <td class="status">
                  <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                </td>

                <td class="options-column">
                  <app-action-button>
                    <button type="button" class="menu-item" (click)="navigateToStudentDetail(u.id)">View details</button>

                    @if (admins.includes(loggedUserRole ?? '')) {
                      <button type="button" class="menu-item" (click)="selectStudent('edit', u)">Edit student</button>

                      <button type="button" class="menu-item" (click)="selectStudent('status', u)">Change status</button>
                    }
                  </app-action-button>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>

  <app-pagination
    [page]="students()?.pagination?.page ?? 0"
    [size]="students()?.pagination?.size ?? 10"
    [totalElements]="students()?.pagination?.totalElements ?? 0"
    [totalPages]="students()?.pagination?.totalPages ?? 0"
    [first]="students()?.pagination?.first ?? true"
    [last]="students()?.pagination?.last ?? false"
    [hasNext]="students()?.pagination?.hasNext ?? false"
    [hasPrevious]="students()?.pagination?.hasPrevious ?? false"
    (pageChange)="loadPage($event)">
  </app-pagination>

</section>


@if (changeStatus()) {
  <section class="pop-up">
    <div class="bg" (click)="changeStatus.set(false)"></div>

    <form #changeStatusForm="ngForm" (ngSubmit)="editStudent(changeStatusForm, 'status')">
      <div class="form-heading">
        <div class="image-box">
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path> <path d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path> <path d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path> <path d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
        </div>
        <div>
          <h6>Change Status</h6>
          <small>Updating status of {{ selectedStudent.first_name + ' ' + selectedStudent.last_name }}</small>
        </div>
      </div>

      <div class="form-container">
        <div class="status">
          <small>Current status:</small>
          <p [ngClass]="selectedStudent.status">{{ selectedStudent.status }}</p>
        </div>

        <div>
          <label for="newStatus">New Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="newStatus" name="newStatus" id="newStatus">
            <option value="" hidden disabled>Select a status</option>

            @for (s of validStatuses; track $index) {
              @if (s !== selectedStudent.status) {
                <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
              }
            }
          </select>
        </div>

        <button class="secondary-button" [disabled]="changeStatusForm.invalid" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Change status
          }
        </button>

      </div>
    </form>
  </section>
}

@if (showEditStudent()) {
  <section class="pop-up">
  <div class="bg" (click)="showEditStudent.set(false)"></div>

  <form #editStudentForm="ngForm" (ngSubmit)="editStudent(editStudentForm, 'edit')">
    <div class="form-heading">
      <div class="image-box">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.1567 9.16214V14.6594M20.1567 9.16214L10.9946 4.58105L1.8324 9.16214L10.9946 13.7432L20.1567 9.16214Z" stroke="white" stroke-width="1.55757"/>
          <path d="M5.49731 10.9946V15.5757C8.24596 18.3244 13.7433 18.3244 16.4919 15.5757V10.9946" stroke="white" stroke-width="1.55757"/>
        </svg>
      </div>

      <div>
        <h6>Edit Student</h6>
        <small>Update details of {{ selectedStudent.first_name + ' ' + selectedStudent.last_name }}</small>
      </div>
    </div>

    <div class="form-container">

      <div>
        <label for="firstName">First Name <span class="required-check">*</span></label>
        <input required placeholder="e.g Naa Adoley" [(ngModel)]="firstName" type="text" name="firstName"
               id="firstName">
      </div>

      <div>
        <label for="lastName">Last Name <span class="required-check">*</span></label>
        <input required placeholder="e.g. Sackey" [(ngModel)]="lastName" type="text" name="lastName" id="lastName">
      </div>

      <div>
        <label for="dob">Date of birth <span class="required-check">*</span></label>
        <input required [(ngModel)]="dob" type="date" name="dob" id="dob" [max]="todayDate">
      </div>

      <div>
        <label for="admissionDate">Admission Date <span class="required-check">*</span></label>
        <input required [(ngModel)]="admissionDate" type="date" name="admissionDate" id="admissionDate"
               [max]="todayDate">
      </div>

      <div>
        <label for="admissionNumber">Admission Number <span class="required-check">*</span></label>
        <input required placeholder="e.g. ADM-2026-0001" [(ngModel)]="admissionNumber" type="text"
               name="admissionNumber" id="admissionNumber">
      </div>

      <div>
        <label for="parentName">Name of Parent/Guardian <span class="required-check">*</span></label>
        <input required placeholder="e.g. Nii Adote Adotey" [(ngModel)]="parentName" type="text" name="parentName" id="parentName">
      </div>

      <div>
        <label for="parentPhone">Phone Number of Parent/Guardian <span class="required-check">*</span></label>
        <input required placeholder="e.g. 050..." [(ngModel)]="parentPhone" type="text" name="parentPhone" id="parentPhone">
      </div>

      <div>
        <label for="parentEmail">Email of Parent</label>
        <input placeholder="e.g. niiadotey@gmail.com" [(ngModel)]="parentEmail" type="email" name="parentEmail" id="parentEmail">
      </div>

      <button class="secondary-button" type="submit" [disabled]="editStudentForm.invalid">
        @if (isEditing()) {
          <app-loading-indicator></app-loading-indicator>
        } @else {
          Update student details
        }
      </button>
    </div>
  </form>
</section>
}

